import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReceiveCompoundDialogComponent } from './receive-compound-dialog.component';
import { GenericWriteTableModule } from 'src/app/shared/components/generic-write-table/genetic-write-table.module';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { DatepickerInputModule } from 'src/app/shared/components/datepicker-input/datepicker-input.module';
import { InputSearchScannerModule } from 'src/app/shared/components/input-search-scanner/input-search-scanner.module';
import { ButtonModule } from 'src/app/shared/components/button/button.module';
import { DestroyIngredientDialogComponent } from '../destroy-ingredient-dialog/destroy-ingredient-dialog.component';
import { AutocompleteModule } from 'src/app/shared/autocomplete/autocomplete.module';
import { AddNoteModule } from 'src/app/dashboard/components/add-note/add-note.module';



@NgModule({
  declarations: [ReceiveCompoundDialogComponent, DestroyIngredientDialogComponent],
  imports: [
    CommonModule,
    DialogModule,
    GenericWriteTableModule,
    FormsModule,
    ReactiveFormsModule,
    InputModule,
    DatepickerInputModule,
    InputSearchScannerModule,
    ButtonModule,
    AutocompleteModule,
    AddNoteModule
  ],
  exports: [ReceiveCompoundDialogComponent]
})
export class ReceiveCompoundDialogModule { }
